module.exports = __webpack_public_path__ + "img/expostyle_9661_pistachio.8c0d7efa.jpg";